const initialise = () => {
    const page = document.querySelector<HTMLBodyElement>('.workflow-theme')
    if (!page) return

    const vacancy = page.querySelector<HTMLDivElement>('.workflow-widget__vacancy')
    const container = page.querySelector<HTMLDivElement>('.banner-workflow .banner-customhtml')
    if (!container || !vacancy) return

    container.appendChild(vacancy)
}

export default {
    initialise
}